<script>
import { required } from "vuelidate/lib/validators";

export default {
  name: "dtsDetails",
  data() {
    return {
      track: null,
      documents: [],
      loading: false,
      submitted: false,
      form: {
        id: "",
        deliveryUnitId: "",
        actionTaken: ""
      },
      selectedDU: this.$store.state.data.selectedDU,
      selectedDepartment: this.$store.state.data.selectedDepartment
    };
  },
  validations: {
    form: {
      actionTaken: { required }
    }
  },
  methods: {
    async getData(props) {
      this.track = null;
      this.documents = [];
      this.loading = true;
      this.submitted = false;
      this.selectedDU = this.$store.state.data.selectedDU;
      this.selectedDepartment = this.$store.state.data.selectedDepartment;
      await this.$bvModal.show("modal-trackDetails");
      await this.getDetails(props);
      await this.getDocuments(props);
      await setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    async getDetails(props) {
      this.$store.dispatch("dtstrack/GetSingleTrack", props.id).then((res) => {
        res.data.type = this.type;
        this.track = res.data;
      });
    },
    async getDocuments(props) {
      this.$store
        .dispatch("dtstrackdocument/GetTrackDocument", props.id)
        .then((res) => {
          this.documents = res.data;
        });
    },
    receiveTrack() {
      console.log(this.selectedDU)
      if (this.selectedDU.withDeliveryUnitAccess || this.$store.state.decrypt.isAdmin()) {
        this.$swal({
          position: "top",
          width: 600,
          title: "You are about to receive this track.",
          text: `Choose wether to recieve this as Delivery Unit (${this.selectedDU.name}) or as Departement (${this.selectedDepartment.departmentName})`,
          icon: "question",
          showCancelButton: true,
          showDenyButton: true,
          cancelButtonColor: "#5c636a",
          denyButtonColor: "#34c38f",
          denyButtonText: "Recieve as Delivery Unit",
          confirmButtonColor: "#349ac3",
          confirmButtonText: "Recieve as Departement",
          customClass: {
            actions: "my-actions",
            denyButton: "order-1",
            confirmButton: "order-2",
            cancelButton: "order-3 left-gap"
          },
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed || result.isDenied) {
            this.$store
              .dispatch("dtstrack/ReceiveTrack", {
                id: this.track.id,
                deliveryUnitId: this.selectedDU.id,
                departmentId: result.isConfirmed
                  ? this.selectedDepartment.id
                  : 0
              })
              .then((res) => {
                this.track.status = "RECEIVED";
                if (result.isConfirmed) {
                  let dashboardData = JSON.parse(
                    localStorage.getItem("dashboardData")
                  );
                  dashboardData.incomingDepartmentTracks =
                    dashboardData.incomingDepartmentTracks - 1;
                  localStorage.setItem(
                    "dashboardData",
                    JSON.stringify(dashboardData)
                  );
                } else {
                  let dashboardData = JSON.parse(
                    localStorage.getItem("dashboardData")
                  );
                  dashboardData.incomingTracks =
                    dashboardData.incomingTracks - 1;
                  localStorage.setItem(
                    "dashboardData",
                    JSON.stringify(dashboardData)
                  );
                }
                this.showToast("Successfully received", "success");
              })
              .catch((err) => {
                this.showToast("Cannot be received!", "error");
              });
          }
        });
      } else {
        this.$swal({
          position: "top",
          title: "Are you sure?",
          text: "You are about to receive this track.",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, receive it!",
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch("dtstrack/ReceiveTrack", {
                id: this.track.id,
                deliveryUnitId: this.selectedDU.id,
                departmentId: this.selectedDepartment
                  ? this.selectedDepartment.id
                  : 0
              })
              .then((res) => {
                this.track.status = "RECEIVED";
                if (this.selectedDepartment) {
                  let dashboardData = JSON.parse(
                    localStorage.getItem("dashboardData")
                  );
                  dashboardData.incomingDepartmentTracks =
                    dashboardData.incomingDepartmentTracks - 1;
                  localStorage.setItem(
                    "dashboardData",
                    JSON.stringify(dashboardData)
                  );
                } else {
                  let dashboardData = JSON.parse(
                    localStorage.getItem("dashboardData")
                  );
                  dashboardData.incomingTracks =
                    dashboardData.incomingTracks - 1;
                  localStorage.setItem(
                    "dashboardData",
                    JSON.stringify(dashboardData)
                  );
                }
                this.showToast("Successfully received", "success");
              })
              .catch((err) => {
                this.showToast("Cannot be received!", "error");
              });
          }
        });
      }
    },
    onReturnTrack() {
      if (this.selectedDU.withDeliveryUnitAccess) {
        this.$swal({
          position: "top",
          width: 600,
          title: "You are about to return this track.",
          text: `Choose wether to return this as Delivery Unit (${this.selectedDU.name}) or as Departement (${this.selectedDepartment.departmentName})`,
          icon: "question",
          showCancelButton: true,
          showDenyButton: true,
          cancelButtonColor: "#5c636a",
          denyButtonColor: "#34c38f",
          denyButtonText: "Return as Delivery Unit",
          confirmButtonColor: "#349ac3",
          confirmButtonText: "Return as Departement",
          customClass: {
            actions: "my-actions",
            denyButton: "order-1",
            confirmButton: "order-2",
            cancelButton: "order-3 left-gap"
          },
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed || result.isDenied) {
            this.form.departmentId = result.isConfirmed
              ? this.selectedDepartment.id
              : 0;
            this.$store
              .dispatch("dtstrack/ReturnTrack", this.form)
              .then((res) => {
                this.track.status = "DRAFT";
                this.$bvModal.hide("modal-returnTrack");
                this.showToast("Successfully returned", "success");
              })
              .catch((err) => {
                this.showToast("Cannot be returned!", "error");
              });
          }
        });
      } else {
        this.$swal({
          position: "top",
          title: "Are you sure?",
          text: "You are about to return this track.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#dc3545",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, return it!",
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch("dtstrack/ReturnTrack", this.form)
              .then((res) => {
                this.track.status = "DRAFT";
                this.$bvModal.hide("modal-returnTrack");
                this.showToast("Successfully returned", "success");
              })
              .catch((err) => {
                this.showToast("Cannot be returned!", "error");
              });
          }
        });
      }
    },
    returnTrack() {
      this.onReset();
      this.form.id = this.track.id;
      this.$bvModal.show("modal-returnTrack");
    },
    onReset() {
      this.submitted = false;
      this.form = {
        id: "",
        deliveryUnitId: this.selectedDU.id,
        departmentId: this.selectedDepartment ? this.selectedDepartment.id : 0,
        actionTaken: ""
      };
    }
  }
};
</script>

<template>
  <div>
    <!-- Return Track -->
    <b-modal
      id="modal-returnTrack"
      title="Return Track"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div>
        <div class="mb-3">
          <label for="actionTaken">Remarks </label>
          <textarea
            id="actionTaken"
            type="text"
            v-model="form.actionTaken"
            placeholder="Enter Remarks..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.actionTaken.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.actionTaken.$error"
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="d-flex float-end">
          <button @click="onReturnTrack" class="btn btn-primary">Return</button>
        </div>
      </div>
    </b-modal>
    <!-- Main -->
    <b-modal
      id="modal-trackDetails"
      title="Track Details"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <div v-if="loading">
        <div class="py-5 d-flex align-items-center justify-content-center">
          <div class="preloader-component me-2">
            <div class="status">
              <div class="spinner-chase w-25px h-25px">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          <h5 class="mb-0">Loading...</h5>
        </div>
      </div>
      <div v-else-if="!track">
        <div class="py-5 d-flex align-items-center justify-content-center">
          <h5 class="mb-0">No Tracks Found</h5>
        </div>
      </div>
      <div v-else>
        <div>
          <div v-if="track.status != 'DRAFT'" class="d-flex float-end mb-3">
            <button
              v-if="track.status == 'PENDING'"
              type="button"
              @click="receiveTrack()"
              class="btn btn-sm btn-success d-flex align-items-center ms-1"
            >
              <i class="bx bx-folder-open fs-6 me-1"></i>Receive Track
            </button>
            <button
              v-if="track.status == 'PENDING' || track.status == 'RECEIVED'"
              type="button"
              @click="returnTrack()"
              class="btn btn-sm btn-warning d-flex align-items-center ms-1"
            >
              <i class="bx bx-undo fs-6 me-1"></i>Return Track
            </button>
          </div>
          <div>
            <div v-if="track.referenceNumber">
              {{ track.referenceNumber }}
            </div>
            <h5 class="mb-0">
              {{ track.title }}
            </h5>
            <div>{{ track.description }}</div>
          </div>
          <hr />
          <div class="px-3">
            <i class="font-size-11">Particulars:</i>
            <ul v-for="document in documents" :key="document.id" class="mt-1">
              <li>{{ document.title }}</li>
            </ul>
          </div>
          <hr />
          <div class="px-3">
            <b-row class="mb-2">
              <b-col class="d-flex justify-content-between font-size-11" sm="5"
                ><i>Destination</i>
                <div>:</div></b-col
              >
              <b-col>
                <div>
                  {{ track.destinationDeliveryUnit.name }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="d-flex justify-content-between font-size-11" sm="5"
                ><i>Action Requested</i>
                <div>:</div></b-col
              >
              <b-col>
                <div>
                  {{ track.actionNeeded }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="d-flex justify-content-between font-size-11" sm="5"
                ><i>Process</i>
                <div>:</div></b-col
              >
              <b-col>
                <div>
                  {{ track.processType.processName }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="d-flex justify-content-between font-size-11" sm="5"
                ><i>Ease of Doing Business</i>
                <div>:</div></b-col
              >
              <b-col>
                <div>
                  {{ track.processType.easeOfDoingBusinessType }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="d-flex justify-content-between font-size-11" sm="5"
                ><i>Estimated Working Days</i>
                <div>:</div></b-col
              >
              <b-col>
                <div>
                  {{ track.processType.estimatedWorkingDays }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="d-flex justify-content-between font-size-11" sm="5"
                ><i>Days to Remind Processor</i>
                <div>:</div></b-col
              >
              <b-col>
                <div>
                  {{ track.processType.daysToRemindOfficeProcessor }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="d-flex justify-content-between font-size-11" sm="5"
                ><i>Created By</i>
                <div>:</div></b-col
              >
              <b-col>
                <div class="mb-1">
                  {{ track.deliveryUnit.name }}
                </div>
                <div class="mb-1 font-size-11">
                  {{ formatDateWithTime(new Date(track.dateTimeCreated)) }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2" v-if="track.status != 'DRAFT'">
              <b-col class="d-flex justify-content-between font-size-11" sm="5"
                ><i>Status</i>
                <div>:</div></b-col
              >
              <b-col>
                <div v-if="track.status == 'RETURNED'">
                  <span class="text-warning">RETURNED</span> to
                  {{ track.deliveryUnit.name }}
                </div>
                <div v-if="track.status == 'PENDING'">
                  <span class="text-info">SENT</span> to
                  {{ track.destinationDeliveryUnit.name }}
                </div>
                <div v-if="track.status == 'RECEIVED'">
                  <span class="text-pink">{{ track.status }}</span> by
                  {{ track.destinationDeliveryUnit.name }}
                </div>
                <div v-if="track.status == 'COMPLETED'">
                  <span class="text-success">PROCESSED</span> by
                  {{ track.destinationDeliveryUnit.name }}
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.my-actions {
  padding: 10px 10px 0 10px;
  font-size: 12px;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.left-gap {
  margin-left: auto;
}

.multiselect__option--group {
  padding-top: 16px;
  padding-bottom: 0;
  background: #2a3042 !important;
  color: #bfc8e2 !important;
  font-weight: bold !important;
  font-size: medium !important;
}
</style>
